export default "__VITE_ASSET__nhG9Su_ZcyBVstOPYzdEEw__";